// extracted by mini-css-extract-plugin
export default {"searchInput":"xTp4O2"};